import * as React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import scripts from '../config/scripts';

interface SEOProps {
  description?: string;
  lang?: string;
  meta?: JSX.IntrinsicElements['meta'][];
  title: string;
}

export const SEO = ({
  description = '',
  lang = 'en',
  meta = [],
  title,
}: SEOProps) => {
  const data = useStaticQuery<GatsbyTypes.SiteSEOQuery>(graphql`
    query SiteSEO {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);
  const { site } = data;
  const metaDescription = site?.siteMetadata?.description ?? description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s · ${site?.siteMetadata?.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site?.siteMetadata?.author ?? undefined,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        ...meta,
      ]}
    >
      {scripts}
    </Helmet>
  );
};
